import { TextField as TextFieldBase } from '@material-ui/core'
import styled from 'styled-components'

export const TextField = styled(TextFieldBase)`
  &&& {
    width: 300px;
  }
`
